module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_02-e554e57d4eaf6273516b3259661a91d1.jpg";